import React, { useState, useRef, useEffect } from "react";
import DropdownSelect from "../common/DropdownSelect.jsx";
import DropdownSelectState from "../common/DropdownSelectState.js";
import DropdownSelectCity from "../common/DropdownSelectCity.js";
import DropdownSelectSZType from "../common/DropdownSelectSZType.js";
import DropdownSelectZSection from "../common/DropdownSelectZSections.js";
import DropdownSelectBoolean from "../common/DropdownSelectBoolean.js";
import { useStates, useCities, GetAllAmenities, GetAllPropertyStatus, GetAllPropertyTypes, GetAllProjectTypes, GetAllConstructionStatus, GetAllNoofBathrooms, GetAllNoofBedrooms, GetAllPostedBy, GetAllPropertyLabel, GetAllPropertyFor, GetAllBooleanValues, GetAllFacingDirections } from "../../APIs/MasterAPIHelper";
import { LocationPicker } from "../common/LocationPicker.js";
import { handleKeyPress, handleKeyPressString, scrollToTop } from "../../APIs/Helper.js";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useSnackbar } from 'notistack';
import { Property,NewProperty } from "../../APIs/APIUrls.js";
import DraggableMarker from "../common/DraggableMarker.js";
import { Link, useFetcher } from "react-router-dom";
import AddPhotos from "./AddPhotos.jsx";
import AddAmenities from "./AddAmenities.jsx";
import AddNearAmenities from "./AddNearAmenities.jsx";
import AddFloorPlan from "./AddFloorPlan.jsx";
import AddDocument from "./AddDocument.jsx";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination2 from "../common/Pagination2.jsx";
import { useNavigate } from "react-router-dom";
import AddProperty2 from "./AddProperty2.jsx";

export default function AddProperty() {

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const vendorid = localStorage.getItem("id") || 0;

  // Safely parse token with fallback
  let Token = null;
  try {
    const tokenStr = localStorage.getItem('tcn');
    Token = tokenStr ? JSON.parse(tokenStr) : null;
  } catch (e) {
    console.error("Error parsing token:", e);
    Token = localStorage.getItem('tcn'); // Fallback to raw token if it's not JSON
  }




  //TypeId 83 for Residential Land  : PropertyType
  //TypeId 103 for New Project : PropertyType

  return (
    <div className="main-content">
      <div className="main-content-inner">
        <div className="button-show-hide show-mb">
          <span className="body-1">Show Dashboard</span>
        </div>
        
        
        <AddProperty2 />
       
      </div>

    
    </div >
  );
}
